import script from "./semanaCalendario.vue?vue&type=script&setup=true&lang=js"
export * from "./semanaCalendario.vue?vue&type=script&setup=true&lang=js"

import "./semanaCalendario.vue?vue&type=style&index=0&id=54ce3289&lang=css"

const __exports__ = script;

export default __exports__